const educationData = [
    {
        school: 'University of California, Davis',
        major: 'B.S. Computer Science | B.S. Statistics | Minor in Technology Management',
        timeFrame: 'Sep 2021 - Jun 2025',
    }, 
]

export default educationData